import React from "react";
import PropTypes from "prop-types";
import { Progress, Row, Col } from "antd";
import { domainColors } from "../components";
import "../../../../../assets/css/sentEmailsPage.css";

const SentEmailsDomainCard = ({ domain, stats }) => {
  const domainColor = domainColors[domain] || domainColors.other;

  // Calculate success percentage
  const successRate = stats.successRate || 0;

  // For our display, count 'sent' status as success if needed
  const successCount = stats.success || 0;
  const sentCount = stats.sent || 0;
  const displaySuccessCount = successCount + sentCount;

  // Handle potential properties not in the API
  const failedCount = stats.failed || 0;
  const totalCount = stats.total || 0;

  return (
    <div className="se-domain-card">
      <div className="se-domain-header">
        <span className="se-domain-name" style={{ color: domainColor }}>
          {domain.charAt(0).toUpperCase() + domain.slice(1)}
        </span>
        <span
          className="se-domain-badge"
          style={{
            backgroundColor: domainColor,
            opacity: 0.9,
          }}
        >
          {totalCount}
        </span>
      </div>

      <div className="se-progress-bar">
        <Progress
          percent={parseFloat(successRate)}
          strokeColor={domainColor}
          size="small"
          showInfo={false}
        />
      </div>

      <div className="se-domain-stats">
        <div className="se-domain-stat">
          <div style={{ color: "#52c41a", fontWeight: "600" }}>
            {displaySuccessCount}
          </div>
          <div style={{ fontSize: "12px", color: "#8c8c8c" }}>Sent</div>
        </div>

        <div className="se-domain-stat">
          <div style={{ color: "#f5222d", fontWeight: "600" }}>
            {failedCount}
          </div>
          <div style={{ fontSize: "12px", color: "#8c8c8c" }}>Failed</div>
        </div>

        {stats.bounced > 0 && (
          <div className="se-domain-stat">
            <div style={{ color: "#fa8c16", fontWeight: "600" }}>
              {stats.bounced}
            </div>
            <div style={{ fontSize: "12px", color: "#8c8c8c" }}>Bounced</div>
          </div>
        )}

        <div className="se-domain-stat">
          <div style={{ fontWeight: "600" }}>{successRate}%</div>
          <div style={{ fontSize: "12px", color: "#8c8c8c" }}>Success Rate</div>
        </div>
      </div>
    </div>
  );
};

SentEmailsDomainCard.propTypes = {
  domain: PropTypes.string.isRequired,
  stats: PropTypes.shape({
    total: PropTypes.number,
    success: PropTypes.number,
    sent: PropTypes.number,
    failed: PropTypes.number,
    bounced: PropTypes.number,
    successRate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
};

export default SentEmailsDomainCard;
